export const loggerFactoryRTTI = Symbol.for("loggerFactory");
export const newableLoggerRTTI = Symbol.for("NewableLogger");
export const loglevelFactoryRTTI = Symbol.for("loglevelFactory");
export const defaultPluginsRTTI = Symbol.for("loggerDefaultPlugins");
export const loggerOptionsRTTI = Symbol.for("LoggerOptions");
export const loggerInstancesRTTI = Symbol.for("LoggerInstances");
